import { render, staticRenderFns } from "./YearsSelectbox.vue?vue&type=template&id=4543c1be&"
import script from "./YearsSelectbox.vue?vue&type=script&lang=js&"
export * from "./YearsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports